/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { isStringNotEmpty } from "utils/empty-exists";
import { objectHasKeys } from "utils/empty-exists";
import { isGuid } from "utils/empty-exists";
// import { Logger } from "cms/utils/log/logger";

const Link = (props) => {

    const guid = props?.link;
    const { token } = useAuth();
    const [linkGuid, setLinkGuid] = useState();
    const [link, setLink] = useState();
    const [isExteranl, setIsExternal] = useState();

    const icon = isExteranl ? " (external link)" : "";

    const loadLink = async () => {
        if (isGuid(guid)) {
            // Logger.debug(`loading link from DB: `, guid)
            const _link = await SimpliCityAdminSDK.link.findOne(token, guid);
            setLink(_link);
            setLinkGuid(_link?.guid);
            return _link;
        }
    };

    useEffect(() => {
        const load = async () => {
            if (isStringNotEmpty(guid)) {
                if (guid) {
                    const _link = await loadLink(guid);
                    setLink(_link);
                    setLinkGuid(_link?.guid);
                    setIsExternal(_link?.is_external);
                }
            }
        };
        // load once
        if (!isGuid(linkGuid)) {
            load();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guid]);

    return (
        <Fragment>
            {objectHasKeys(link) &&
                <Fragment >
                    <a href={link.url}>{link.text}{icon}</a>
                </Fragment>
            }
        </Fragment>
    );
};

export default Link;
